export function authErrorCodeToMessage(errCode) {
    const errorCodes = {
        'auth/email-already-in-use': "このメールアドレスは既に登録されています。",
        'auth/invalid-email': "メールアドレスの形式が無効です。",
        'auth/operation-not-allowed': "このアカウントは無効になってます。",
        'auth/weak-password': "パスワードが脆弱です。",
        'auth/user-not-found': "そのメールアドレスは登録されていません。",
        'auth/wrong-password': "パスワードが間違っています。"
    }
    return errorCodes[errCode] ? errorCodes[errCode] : "エラーが発生しました。"
}
export function crudErrorCodeToMessage(errCode) {
    const errorCodes = {
        'auth/email-already-in-use': "このメールアドレスは既に登録されています。",
        'auth/invalid-email': "メールアドレスの形式が無効です。",
        'auth/operation-not-allowed': "このアカウントは無効になってます。",
        'auth/weak-password': "パスワードが脆弱です。",
        'auth/user-not-found': "そのメールアドレスは登録されていません。",
        'auth/wrong-password': "パスワードが間違っています。"
    }
    return errorCodes[errCode] ? errorCodes[errCode] : "エラーが発生しました。"
}